module.exports = __webpack_public_path__ + "static/media/crossword.7ea41cd0.png";